/**
 * @generated SignedSource<<46dec638180baf2c8e4e9ff329fe9898>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoOverviewListItemMedium_Todo$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoOverviewListItemMediumDescription_Todo" | "TodoOverviewListItemMediumFooter_Todo" | "TodoOverviewListItemMediumStatusAndPrio_Todo">;
  readonly " $fragmentType": "TodoOverviewListItemMedium_Todo";
};
export type TodoOverviewListItemMedium_Todo$key = {
  readonly " $data"?: TodoOverviewListItemMedium_Todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoOverviewListItemMedium_Todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoOverviewListItemMedium_Todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoOverviewListItemMediumDescription_Todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoOverviewListItemMediumFooter_Todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoOverviewListItemMediumStatusAndPrio_Todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "d01a8b2995ba6e0ba014e1dee3141da1";

export default node;
